module.exports = __webpack_public_path__ + "static/blog-2104ba29d5deca9ee0ff36f98dcada7d.png";